module.exports = __webpack_public_path__ + "img/myjl@2x.a75af09f.png";